import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";
import { ContainerImageStatus } from "types/constants";

export type ContainerDjango = {
  id: number;
  name: string;
  label: string;
  date_created: string;
  date_updated: string;
  tags: string[] | null;
  description: string | null;
  full_name: string;
  readme: string | null;
  size: number;
  user: {
    id: string;
    email: string;
    full_name: string;
  } | null;
  tenant: {
    id: number;
    name: string;
    key: string;
  } | null;
  tools: {
    id: number;
    name: string;
  }[];
  status: ContainerImageStatus;
};

export const ALL_CONTAINERS_QUERY_KEY = "all_containers";

export const useAllContainersQuery = () => {
  return useQuery<ContainerDjango[], Error>({
    queryKey: [ALL_CONTAINERS_QUERY_KEY],
    queryFn: async () => {
      const baseUrl = getEnvVar("URL_TES");
      const url = `${baseUrl}image/browse/`;
      const headers = await getRequestHeaders();
      const res = await axios.get<ContainerDjango[]>(url, { headers });
      return res.data;
    },
  });
};
